/**
 * @generated SignedSource<<12f5e9bd29a0c25d6005a34238fa1de5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodCreditCardSelected_charge$data = {
  readonly company: {
    readonly features: ReadonlyArray<string | null | undefined> | null | undefined;
  } | null | undefined;
  readonly customer: {
    readonly id: string;
  } | null | undefined;
  readonly id: string;
  readonly status: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveWaitingPaymentMethodCreditCard_charge" | "PaymentCompleted_charge" | "PaymentMethodCreditCardSelectedProcessing_charge" | "PaymentMethodCreditCardSteps_charge" | "PaymentMethodSelectedCustomerRegister_charge" | "useChargePaymentMethod_charge">;
  readonly " $fragmentType": "PaymentMethodCreditCardSelected_charge";
};
export type PaymentMethodCreditCardSelected_charge$key = {
  readonly " $data"?: PaymentMethodCreditCardSelected_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodCreditCardSelected_charge">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "method",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodCreditCardSelected_charge",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "features",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "customer",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCompleted_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActiveWaitingPaymentMethodCreditCard_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodCreditCardSelectedProcessing_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodSelectedCustomerRegister_charge"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useChargePaymentMethod_charge",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "availablePaymentMethods",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "paymentMethods",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "brCode",
                  "storageKey": null
                },
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "valueWithDiscount",
                  "storageKey": null
                }
              ],
              "type": "PaymentMethodPix",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/)
              ],
              "type": "PaymentMethodInstallments",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "installmentNumber",
                  "storageKey": null
                },
                (v3/*: any*/)
              ],
              "type": "PaymentMethodCreditCard",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v1/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "consentId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "authorizationUrl",
                  "storageKey": null
                }
              ],
              "type": "PaymentMethodITP",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "boletoBarcode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "boletoDigitable",
                  "storageKey": null
                },
                (v3/*: any*/)
              ],
              "type": "PaymentMethodBoleto",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodCreditCardSteps_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};
})();

(node as any).hash = "db415ec94a26542b160572e618479e6c";

export default node;
